module.exports = __webpack_public_path__ + "img/icons BFr_31.67e27f40.svg";